module.exports = __webpack_public_path__ + "img/fallback-card-01.8a70b8f.jpg";